import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { onEnter } from '../../../utilities/accessibility/onEnter';
import '../../../styles/scss/filters/autocomplete-input.scss'

const AutoCompleteInput = ({
    className,
    isAutoCompleteDisabled,
    name,
    onSubmit,
    placeHolder,
    suggestions,
}) => {
  const textInput = useRef();
  const [input, setInput] = useState('');
  const [suggestionList, setSuggestionList] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);

  const onInputChange = event => {
    const userInput = _.get(event, 'target.value');
    const filteredSuggestions = userInput
      ? _.filter(
        suggestions,
        suggestion => userInput && _.includes(suggestion.toLowerCase(), userInput.toLowerCase()),
      ) : [];
    setInput(userInput);
    setSuggestionList(filteredSuggestions);
  }

  const onKeyDown = e => {
    // ENTER
    if (e.keyCode === 13 && suggestionList[activeSuggestionIndex]) {
      onSubmit(suggestionList[activeSuggestionIndex])  ;
      setInput('');
      setActiveSuggestionIndex(0);
      setSuggestionList([]);
    // UP ARROW
    } else if (e.keyCode === 38 && activeSuggestionIndex !== 0) {
        setActiveSuggestionIndex(activeSuggestionIndex - 1);
    // DOWN ARROW
    } else if (e.keyCode === 40 && (activeSuggestionIndex + 1) < suggestionList.length) {
      setActiveSuggestionIndex(activeSuggestionIndex + 1);
    }
  }

  const onClickSuggestion = e => {
    onSubmit(e.target.innerText);
    setInput('');
    setActiveSuggestionIndex(0);
    setSuggestionList([]);
  }

  const onAutoCompleteDisabledSubmit = () => {
    const { current } = textInput;
    onSubmit(current.value);
    setInput('');
    setActiveSuggestionIndex(0);
    setSuggestionList([]);
  };

  const displaySuggestions = (
    <ul className="suggestions" >
      {_.map(suggestionList, (suggestion, index) => (
        <li
          id="autocomplete-item"
          key={`${index}-${suggestion}`}
          className={index === activeSuggestionIndex ? 'suggestion-active' : ''}
          onClick={onClickSuggestion}
        >
          {suggestion}
        </li>
      ))}
    </ul>
  );

  const emptySuggestions = (
    <div className="no-suggestions" >
      <em>Sorry, no matches.</em>
    </div>
  );

  return (
    <div className="autocomplete">
      <input type="text"
        ref={textInput}
        onChange={onInputChange}
        name={name}
        className={className}
        onKeyDown={isAutoCompleteDisabled
          ? event => onEnter(event, onAutoCompleteDisabledSubmit)
          : onKeyDown}
        autoComplete="off"
        placeholder={placeHolder}
        value={input}
      />
      {!isAutoCompleteDisabled && input && (
        _.isEmpty(suggestionList)
          ? emptySuggestions
          : displaySuggestions
      )}
    </div>
  )
}

AutoCompleteInput.propTypes = {
  className: PropTypes.string,
  isAutoCompleteDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
}

AutoCompleteInput.defaultProps = {
  className: '',
  isAutoCompleteDisabled: false,
  placeHolder: '',
};

export default AutoCompleteInput;